export default {
  title: 'Aktualizacje',
  fields: {
    app_version: 'Wersja aplikacji',
    description: 'Opis',
    created_at: 'Utworzono',
  },
};
